import { validateDocument } from './validDocument';

const CNPJ_LENGTH = 14;
const CNPJ_SEGMENTS = [
  { end: 2, prefix: '' },
  { end: 5, prefix: '.' },
  { end: 8, prefix: '.' },
  { end: 12, prefix: '/' },
  { end: 14, prefix: '-' },
];

export const onlyCnpjDigits = (raw) => (raw == null ? '' : String(raw).replace(/\D/g, '').slice(0, CNPJ_LENGTH));

export const maskCnpj = (raw) => {
  const digits = onlyCnpjDigits(raw);
  let masked = '';
  let start = 0;
  CNPJ_SEGMENTS.forEach(({ end, prefix }) => {
    const segment = digits.slice(start, end);
    if (segment) masked += prefix + segment;
    start = end;
  });
  return masked;
};

export const formatCnpj = (stored) => maskCnpj(stored);

export const normalizeCnpjInput = (raw) => (raw == null ? '' : String(raw).replace(/[./\-\s]/g, ''));

export const isValidCnpj = (raw) => {
  const normalized = normalizeCnpjInput(raw);
  if (!/^[0-9]{14}$/.test(normalized)) return false;
  const parsed = validateDocument(normalized);
  return !!parsed && parsed.type === 'cnpj';
};
